export const M_TbmEntry_BASIC_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
    },
  },
};
